import React from 'react';
import { StaffMembersDataHooks } from './dataHooks';
import { TagName } from '../../../../utils/tagName.const';
import { StaffMember } from '@wix/bookings-uou-types';
import Text, { TextType } from '../../Text/Text';
import { TFunction, useTranslation } from '@wix/yoshi-flow-editor';
import { FormService } from '../../../../utils/mappers/serviceMapper/service.mapper';
import { ServiceType } from '@wix/ambassador-bookings-services-v2-service/types';

export interface StaffMembersProps {
  service: FormService;
}

const StaffMembers: React.FC<StaffMembersProps> = ({ service }) => {
  const { t } = useTranslation();
  const staffMemberNames = getStaffMembers(service, t);

  return (
    <Text
      type={TextType.Secondary}
      data-hook={StaffMembersDataHooks.STAFF_MEMBER}
      tagName={TagName.Paragraph}
    >
      {staffMemberNames}
    </Text>
  );
};

const getStaffMembers = (service: FormService, t: TFunction) => {
  const staffMembers: StaffMember[] = service.staffMembers || [];
  if (staffMembers.length || service.type !== ServiceType.APPOINTMENT) {
    return staffMembers.map((staffMember) => staffMember.name).join(', ');
  }
  return t('app.bookings-form.appointment-details.first-available');
};

export default StaffMembers;
